<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_834_118930)">
<path d="M12 6.85712V17.1428" stroke="#7586B0" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.85712 12H17.1428" stroke="#7586B0" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 0.857117H5.99997C3.15966 0.857117 0.857117 3.15966 0.857117 5.99997V18C0.857117 20.8404 3.15966 23.1428 5.99997 23.1428H18C20.8404 23.1428 23.1428 20.8404 23.1428 18V5.99997C23.1428 3.15966 20.8404 0.857117 18 0.857117Z" stroke="#7586B0" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_834_118930">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
